import { IIconProps } from './constants';

export const FilterIcon = ({ height = 24, width = 24, ariaLabel = '' }: IIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="minus-circle-icon"
      aria-labelledby={ariaLabel}
    >
      <path d="M21 16.5H12" stroke="currentcolor" strokeWidth="2" strokeLinecap="round" />
      <path d="M6 16.5H3" stroke="currentcolor" strokeWidth="2" strokeLinecap="round" />
      <circle cx="8.5" cy="16.5" r="2.5" stroke="currentcolor" strokeWidth="2" />
      <path d="M3 8.5L12 8.5" stroke="currentcolor" strokeWidth="2" strokeLinecap="round" />
      <path d="M18 8.5L21 8.5" stroke="currentcolor" strokeWidth="2" strokeLinecap="round" />
      <circle
        cx="15.5"
        cy="8.5"
        r="2.5"
        transform="rotate(-180 15.5 8.5)"
        stroke="currentcolor"
        strokeWidth="2"
      />
    </svg>
  );
};
